import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
export function UrgencySection() {
  const [ref, vis] = useReveal();
  // 7 min 50 sec countdown
  const [timeLeft, setTimeLeft] = useState(7 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 7 * 60 + 50; // Reset loop for demo purposes
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-black py-10 px-5 sm:px-6 border-t border-white/5" data-id="element-326">
      <div className="container mx-auto max-w-3xl" data-id="element-327">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-328">
          <div className="inline-block bg-[#111111] border border-[#eab308]/30 rounded-2xl p-6 md:p-8 w-full shadow-[0_0_30px_rgba(234,179,8,0.1)]" data-id="element-329">
            <h3 className="text-[#eab308] font-bold text-sm md:text-base tracking-widest uppercase mb-4" data-id="element-330">
              ⏰ PRECIO DE RELANZAMIENTO — CIERRA EN:
            </h3>

            <div className="flex justify-center items-center gap-2 md:gap-4 mb-4" data-id="element-331">
              <div className="flex flex-col items-center" data-id="element-332">
                <div className="bg-black border border-white/10 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-white font-serif" data-id="element-333">
                  {hours.toString().padStart(2, '0')}
                </div>
                <span className="text-gray-500 text-xs mt-2 uppercase tracking-wider" data-id="element-334">
                  hs
                </span>
              </div>
              <span className="text-2xl md:text-4xl font-bold text-gray-600 pb-6" data-id="element-335">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-336">
                <div className="bg-black border border-white/10 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-white font-serif" data-id="element-337">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <span className="text-gray-500 text-xs mt-2 uppercase tracking-wider" data-id="element-338">
                  min
                </span>
              </div>
              <span className="text-2xl md:text-4xl font-bold text-gray-600 pb-6" data-id="element-339">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-340">
                <div className="bg-black border border-white/10 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-[#eab308] font-serif" data-id="element-341">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <span className="text-gray-500 text-xs mt-2 uppercase tracking-wider" data-id="element-342">
                  seg
                </span>
              </div>
            </div>

            <p className="text-red-400 font-bold text-sm md:text-base mb-6" data-id="element-343">
              ⚠️ Después sube. No vuelve.
            </p>

            <div className="w-full max-w-md mx-auto text-left" data-id="element-344">
              <div className="flex justify-between text-xs md:text-sm font-bold mb-2" data-id="element-345">
                <span className="text-white" data-id="element-346">
                  🔴 Cupos al precio de relanzamiento
                </span>
                <span className="text-[#eab308]" data-id="element-347">68%</span>
              </div>
              <div className="w-full bg-black rounded-full h-2.5 border border-white/10 overflow-hidden" data-id="element-348">
                <div className="bg-gradient-to-r from-red-600 to-[#eab308] h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-349"></div>
              </div>
              <p className="text-gray-500 text-xs text-center mt-2" data-id="element-350">
                68% de los cupos ya tomados
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}